module.exports = __webpack_public_path__ + "media/my_images/search/random-03fce11162b15bdef9b89aabc07a5112.png";